import React from 'react'
import { getDayOfWeek } from '../helpers/getWeekday'
import { formatVariant } from '../helpers/formatVariant'
import UserIcon from '../icons/User'
import styles from './PrintCateringProductionList.module.css'
import { ProductionListItem } from '../helpers/groupProductionLists'
import Comment from '../icons/Comment'

interface Props {
  productionList: ProductionListItem[]
  date: string
}

function PrintCateringProductionList({ productionList, date }: Props) {
  const dayOfWeek = React.useMemo(() => {
    return getDayOfWeek(date)
  }, [date])

  return productionList ? (
    <div className={styles.page}>
      <div>
        <h1 className={styles.heading}>
          Leveransdatum: {dayOfWeek}, {date}
        </h1>
        {productionList.map((product) => {
          return (
            <div className={styles.productContainer} key={product.productId}>
              <div 
                style={{ borderBottom: product.totalAmount === 0 ? '1px solid var(--grayLight)' : '0px' }}
                className={styles.productHeading}
              >
                <span className={styles.productName}>{product.productName}</span>
                <span className={styles.productTotalAmount}>({product.totalAmount})</span>
              </div>
              {product.groupedOrders.map((order, index) => {
                if (order.totalVariantAmount > 0) {
                  return (
                    <div className={styles.variantContainer} key={`${product.productId}-${order.variantId}`}>
                      <div className={styles.variantHeader} style={{ borderRadius: index === 0 ? '0px' : '4px 4px 0px 0px' }}>
                        <span className={styles.variantAmount}>{order.totalVariantAmount} st {product.productName}</span>
                        {order.variantName && 
                            <div className={styles.variantDetails}> 
                              {formatVariant(order.variantName)?.map((variant: string, index: number) => (
                                <span className={styles.variant} key={order.variantId + index}>{variant}</span>
                              ))}
                            </div>
                        }
                      </div>
                      <div className={styles.orderList}>
                        {order.orders.map((o, index) => {
                          return (
                            <div key={`${product.productId}_${order.variantId}_${o.orderNumber}_${index}`}>
                              <div
                                className={styles.orderRow}
                                style={{ borderTop: index !== 0 ? '1px solid #acacac' : '0px' }}
                              >
                                <span className={styles.orderAmount}>{o.amount} st</span>
                                <div className={styles.orderCustomer}>
                                  <span className={styles.userIcon}> <UserIcon /> </span>
                                  <span className={styles.orderCustomerName}>{o.userName}</span>
                                </div>
                                {o.deliveryDisplayName}{o.deliveryTimeSlot ? `: ${o.deliveryTimeSlot}` : ''}
                                <span className={styles.orderNumber}>{o.orderNumber.toUpperCase()}</span>
                              </div>
                              {(o.orderComment || o.productComment || o.storeComment) && (
                                <div className={styles.commentContainer}>
                                  <Comment className={styles.commentIcon} color='var(--text)'/>
                                  <div className={styles.commentContent}>
                                    {o.productComment && (
                                      <span><span className={styles.commentLabel}>Meddelande från kund:</span> {o.productComment}</span>
                                    )}
                                    {o.orderComment && (
                                      <span><span className={styles.commentLabel}>Övrigt meddelande från kund:</span> {o.orderComment}</span>
                                    )}
                                    {o.storeComment && (
                                      <span><span className={styles.commentLabel}>Intern butikskommentar:</span> {o.storeComment}</span>
                                    )}
                                  </div>
                                </div> 
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          )
        })}
      </div>
    </div>
  ) : null
}

export default PrintCateringProductionList
